export enum NOTIFICATION {
  SHOW_NOTIFICATION = "NOTIFICATION.SHOW_NOTIFICATION",
}
